import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=138deca3&scoped=true&"
import script from "./BaseIconButton.vue?vue&type=script&lang=ts&"
export * from "./BaseIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=138deca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138deca3",
  null
  
)

export default component.exports